<template>
  <div class="content">
    <div v-if="flag == -1 || flag == 2">
      <div class="option">
        <span>姓名：</span>
        <div class="option-con">
          <input type="text" placeholder="请输入姓名" v-model="username" />
        </div>
      </div>
      <div class="option">
        <span>性别：</span>
        <div class="option-con">
          <div class="sex">
            <div @click="sex = 1">
              <div :class="sex == 1 ? 'radio-check' : 'radio'"></div>
              <span>男</span>
            </div>
            <div @click="sex = 0">
              <div :class="sex == 0 ? 'radio-check' : 'radio'"></div>
              <span>女</span>
            </div>
          </div>
        </div>
      </div>
      <div class="option">
        <span>年龄：</span>
        <div class="option-con">
          <input type="text" placeholder="请入您的年龄" v-model="year" />
        </div>
      </div>
      <div class="option">
        <span>手机号：</span>
        <div class="option-con">
          <input type="text" placeholder="请输入手机号码" v-model="mobile" />
        </div>
      </div>
      <div class="option">
        <span>微信号：</span>
        <div class="option-con">
          <input type="text" placeholder="请输入微信号码" v-model="qq" />
        </div>
      </div>
      <div class="option">
        <span>擅长方式：</span>
        <div class="option-con">
          <input type="text" placeholder="请输入您擅长的方式" v-model="modes" />
        </div>
      </div>
      <div class="option">
        <span>从业经验：</span>
        <div class="option-con">
          <input
            type="text"
            placeholder="请输入您的从业经验"
            v-model="introduction"
          />
        </div>
      </div>
      <div class="up-id">
        <div class="up-id-t">上传身份证照</div>
        <div class="img-id">
          <div>
            <div class="img" @click="updataimg(0)">
              <van-image
                fit="cover"
                width="100%"
                height="100%"
                :src="
                  identity_just
                    ? identity_just
                    : require('../../../assets/mine/ahead.png')
                "
                alt=""
              />
            </div>
            <p><span>*</span>身份证人像面</p>
          </div>
          <div>
            <div class="img" @click="updataimg(1)">
              <van-image
                fit="cover"
                width="100%"
                height="100%"
                :src="
                  identity_back
                    ? identity_back
                    : require('../../../assets/mine/pos.png')
                "
                alt=""
              />
            </div>
            <p><span>*</span>身份证国徽面</p>
          </div>
        </div>
      </div>

      <div class="buton" @click="submit">提交信息</div>
      <uploader style="display: none" ref="upload" :after-read="afterRead" />
    </div>
    <div v-if="flag == 0" class="g-page">
      <img src="@/assets/g.png" class="g-img" alt="" />
      <div class="g-title">申请信息提交成功</div>
      <div class="g-font1">感谢您的申请！</div>
      <div class="g-font1 g-font2">
        平台运营人员将在7个工作日内通过电话/QQ与您联
        系，请保持电话畅通并主意消息
      </div>
      <div class="g-font1">可以测期待您的加入！</div>
    </div>
    <div v-if="flag == 1" class="g-page">
      <img src="@/assets/g.png" class="g-img" alt="" />
      <div class="g-title">申请信息提交成功</div>
      <div class="g-font1">感谢您的申请！</div>
      <div class="g-font1 g-font2">
        平台运营人员将在7个工作日内通过电话/QQ与您联
        系，请保持电话畅通并主意消息
      </div>
      <div class="g-font1">可以测期待您的加入！</div>
    </div>
  </div>
</template>

<script>
/**
@description:老师招募
@createTime:2021-09-23
@create:wq
*/
import { Uploader } from "vant";
import { uploadimg } from "../../../utils/tool";

export default {
  name: "",
  props: {},
  components: { Uploader },
  data() {
    return {
      username: "",
      sex: 1,
      year: "",
      mobile: "",
      qq: "",
      modes: "",
      introduction: "",
      identity_just: "",
      identity_back: "",
      idIndex: 0,
      flag: -1,
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    let user = JSON.parse(localStorage.getItem("user"));
    this.flag = user.teacherExamine;
    console.log(this.flag, "------------");
  },
  methods: {
    submit() {
      const {
        username,
        sex,
        year,
        mobile,
        qq,
        modes,
        introduction,
        identity_just,
        identity_back,
      } = this;

      if (!username) {
        return this.Toast("请输入姓名");
      }
      if (!year) {
        return this.Toast("请输入年龄");
      }
      if (!mobile) {
        return this.Toast("请输入手机号");
      }
      if (!qq) {
        return this.Toast("请输入微信号");
      }
      if (!modes) {
        return this.Toast("请输入擅长方式");
      }
      if (!introduction) {
        return this.Toast("请输入从业经验");
      }
      if (!identity_just) {
        return this.Toast("请上传身份证人像面");
      }
      if (!identity_back) {
        return this.Toast("请上传身份证国徽面");
      }

      this.api
        .becomeTeacher({
          username,
          sex,
          year,
          mobile,
          qq,
          introduction,
          identity_just,
          identity_back,
        })
        .then(() => {
          this.Toast.success("提交成功");
          setTimeout(() => {
            this.$router.go(-1);
          }, 2000);
        });
    },
    async afterRead(file) {
      const imgurl = await uploadimg(file);
      if (imgurl) {
        if (this.idIndex == 0) {
          this.identity_just = imgurl.complete_url;
        } else if (this.idIndex == 1) {
          this.identity_back = imgurl.complete_url;
        }
      }
    },
    updataimg(index) {
      this.idIndex = index;
      this.$refs.upload.chooseFile();
    },
  },
};
</script>

<style lang="scss" scoped>
.g-page {
  padding-top: 2rem;
  text-align: center;
}
.g-img {
  width: 1.2rem;
  height: 1.2rem;
  margin: 0 auto;
  margin-bottom: 0.24rem;
}
.g-title {
  font-size: 0.32rem;
  color: #333333;
  text-align: center;
  font-weight: bold;
  margin-bottom: 1.28rem;
}
.g-font1 {
  font-size: 0.24rem;
  color: #999999;
}
.g-font2 {
  padding: 0 0.8rem;
  margin-bottom: 0.36rem;
}
.content {
  margin: 0 0.2rem;
}
.option {
  display: flex;
  align-items: center;
  font-size: 0.3rem;
  color: #333333;
  border-bottom: 1px solid #dddddd;
  padding: 0.5rem 0;
  &.optionin {
    border-bottom: 0;
    justify-content: center;
  }
  .option-con {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    input {
      width: 100%;
      border: none;
      outline: none;
    }
    > span {
      width: 100%;
    }
    .sex {
      display: flex;
      align-items: center;
      > div {
        display: flex;
        align-items: center;
        margin-right: 100px;
        span {
          margin-left: 15px;
        }
      }
    }
    .placeholder {
      color: #999999;
    }
  }
  i {
    color: #cccccc;
    font-size: 12px;
  }
}
.buton {
  margin: 40px 0;
}

.up-id {
  margin-top: 0.5rem;
}
.up-id-t {
  font-size: 0.32rem;
  font-weight: bold;
  color: #333333;
}
.img-id {
  margin-top: 0.2rem;
  display: flex;
  justify-content: space-between;
  .img {
    width: 3.45rem;
    height: 2.02rem;
    box-sizing: border-box;
  }
  p {
    color: #666666;
    font-size: 0.28rem;
    text-align: center;
    margin-top: 0.3rem;
    span {
      font-weight: 500;
      color: #fb2f4c;
    }
  }
}
</style>
